import { triggerTrackingEvent } from './analytics';

const MODAL_TRIGGER_SELECTOR = '[data-modal="true"]';

// Set while the widget wrapper forwards its click to the modal button
let isForwardedModalClick = false;

export const handleWidgetClick = ({
	event,
	url,
	enableOpenNewWindow,
	enableDialogWindow,
	elementCTA,
	windowId,
	isClickableModal,
	wiapiOnClick,
	ariaLabel = '',
	isAnchor,
	reactElementText
}) => {
	// A nested modal trigger (the CTA button) handles its own click and tracking,
	// the platform dialog script then opens the modal once the click bubbles up
	const modalTrigger = event.target?.closest?.(MODAL_TRIGGER_SELECTOR);
	if (
		modalTrigger &&
		modalTrigger !== event.currentTarget &&
		event.currentTarget?.contains?.(modalTrigger)
	) {
		return;
	}

	event.preventDefault();

	triggerTrackingEvent({
		element: 'ws-content-cta Call to action',
		elementCTA,
		url,
		elementType: isAnchor ? 'anchor' : 'notAnchorNorButton',
		result: `Navigated to ${url}`,
		windowId,
		ariaLabel,
		reactElementText
	});

	// Clicking the wrapper of a dialog enabled widget should open the modal
	// through the button instead of navigating to the url. The wrapper click
	// is already tracked above, so the forwarded button click is not tracked again
	const modalButton =
		enableDialogWindow && !isClickableModal && !wiapiOnClick
			? event.currentTarget?.querySelector?.(MODAL_TRIGGER_SELECTOR)
			: null;
	if (modalButton) {
		isForwardedModalClick = true;
		try {
			modalButton.click();
		} finally {
			isForwardedModalClick = false;
		}
		return;
	}

	if (wiapiOnClick) {
		/** WIAPI is hijacking the default click behaviour of the widget */
		wiapiOnClick?.();
	} else if (!isClickableModal) {
		if (enableOpenNewWindow) {
			window.open(url);
		} else {
			window.location.href = url;
		}
	}
};

export const handleButtonClick = ({
	event,
	isClickableDivElement,
	enableDialogWindow,
	element,
	elementCTA,
	result,
	windowId,
	wiapiOnClick
}) => {
	const isModalTrigger = enableDialogWindow && !wiapiOnClick;
	// The platform dialog script listens for clicks higher up the DOM, so a
	// modal button must let the click bubble while preventing navigation
	if (isModalTrigger) {
		event.preventDefault();
	} else {
		event.stopPropagation();
	}
	// Disable event to allow clickable wrapper to apply window.location
	if (isClickableDivElement || wiapiOnClick) {
		event.preventDefault();
	}
	if (!isForwardedModalClick) {
		triggerTrackingEvent({
			element,
			elementCTA,
			url: result,
			elementType: 'button',
			result: `Navigated to ${result}`,
			windowId
		});
	}
	if (wiapiOnClick) {
		wiapiOnClick();
	}
};
